export const FETCH_PIH_EQUIPMENT_CATEGORY = '@@pihEquipmentCategory/fetch-pihEquipmentCategory';
export const FETCH_PIH_EQUIPMENT_CATEGORY_SUCCESS =
  '@@pihEquipmentCategory/fetch-pihEquipmentCategory-success';
export const FETCH_PIH_EQUIPMENT_CATEGORY_FAILURE =
  '@@pihEquipmentCategory/fetch-pihEquipmentCategory-failure';
